(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"), require("FEGORender"), require("FEGOEditor"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi", "FEGORender", "FEGOEditor"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/lottery3/render"] = factory(require("FEGOWebapi"), require("FEGORender"), require("FEGOEditor"));
	else
		root["/fego/component/lottery3/render"] = factory(root["FEGOWebapi"], root["FEGORender"], root["FEGOEditor"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__4183__) => {
return 